import Form from "./Form";
import ConcentricLoader from "@hudson/ui/components/Loader/ConcentricLoader";
import Session from "@lib/session";
import { useFrequentRiderPointsQuery, useFrequentRiderProgramsQuery } from "@graphql/api";

export default function FrequentRiderPoints() {
  const {
    data: pointsData,
    loading: pointsLoading,
    error,
  } = useFrequentRiderPointsQuery({
    variables: { id: Session.getBooking().profiles.user },
  });
  const { data: programsData, loading: programsLoading } = useFrequentRiderProgramsQuery();

  if (error) {
    console.error(error);
    return null;
  }

  return pointsLoading || programsLoading ? (
    <ConcentricLoader className="opacity-60 max-w-2xl mx-auto px-4 sm:py-10 sm:px-6 lg:px-8" />
  ) : (
    <Form points={pointsData?.frequentRiderPoints} programs={programsData?.frequentRiderPrograms} />
  );
}
